<template>
	<div class="listing grid_3" v-if="loaded == true">
		<div class="listing_heading">
			<h2>{{ this.title }}</h2>
			<input type="search" v-model="search" :placeholder="'Search ' + this.title">
			<div class="select_wrapper">
				<select class="styled_select" v-model="sort" v-on:change="getActivities()">
					<option v-for="(option, value) in sort_options" :value="value">{{ option }}</option>
				</select>
			</div>
			<ul class="filter" v-if="tags.length > 1">
				<li :style="'--accent:'+accent" :class="{ active: filter == '' }"><label><input type="radio" :name="type" value="" v-model="filter" v-on:change="getActivities()">All</label></li>
				<li :style="'--accent:'+accent" :class="{ active: filter == tag.name.en }" v-for="tag in tags"><label><input type="radio" :name="type" :value="tag.name.en" v-model="filter" v-on:change="getActivities()">{{ tag.name.en }}</label></li>
			</ul>
		</div>
		<template v-if="activities.length >= 1">
			<div is="activity-listing-item" v-for="(activity, key) in activities" v-if="key < page_end" :activity="activity" :listing_type="listing_type" :accent="accent" :base_participants="base_participants" class="listing_item" :key="key"></div>
			<div class="pagination_wrapper" v-if="activities.length > page_end">
				<button type="button" class="button solid primary" v-on:click="showMore()" style="display: block; margin: 0 auto;">Show More</button>
			</div>
		</template>
		<template v-else>
			<p style="text-align: center; grid-column: 1/-1;">No results</p>
		</template>
	</div>
</template>
<script>
import debounce from '../vendor/debounce.js'
import { mapGetters, mapActions } from 'vuex';
export default {

	directives: { debounce },
	
	props: [
		'type',
		'destination_id',
		'activities_per_page',
		'accent',
		'listing_type',
		'base_participants',
		'tags'
	],

	data: () => {
		return {
			activities: [],
			sort_options: { name: 'A-Z', popularity: 'Most Popular' },
			sort: 'popularity',
			filter: '',
			search: '',
			page_end: 0,
			loaded: false,
		}
	},

	computed: {
		title() {
			return this.type == 'Activity' ? 'Activities' : this.type;
		}
	},

	created() {
	},

	mounted() {
		this.getActivities();
	},

	watch: {
		search: debounce(function(value){
			this.getActivities();
		},500)
	},

	methods: {
		getActivities: function (type) {
			this.activities = [];
			this.page_end = parseInt(this.activities_per_page);
			this.$nextTick(function () {
				axios.post('/ajax/getActivities', {
					destination_id: parseInt(this.destination_id), 
					type: this.type,
					sort: this.sort,
					filter: this.filter,
					search: this.search
				})
				.then(response => {
					this.activities = response.data;
					this.$nextTick(function () {
						if (this.activities.length > 0) {
							this.loaded = true;
						}
						this.initStyledSelect();
					});		
				})
				.catch(error => {
					console.log(error);
				});
			});
		},

		showMore: function () {
			if (this.page_end < this.activities.length) {
				this.page_end = this.page_end + parseInt(this.activities_per_page);
			}
		},

		initStyledSelect: function () {
			// do a pure javascript version of the select wrapper code
			for (var i = 0; i < document.querySelectorAll(".form_style select, .styled_select").length; i++) {
				var elem = document.querySelectorAll(".form_style select, .styled_select")[i];
				if (!elem.parentElement.classList.contains('select_wrapper')) {
					var wrapper = document.createElement('div');
					wrapper.classList.add("select_wrapper");
					this.wrap(elem, wrapper);
				}
			}
		},

		wrap: function(el, wrapper) {
			el.parentNode.insertBefore(wrapper, el);
			wrapper.appendChild(el);
		},

	}
};
</script>